import { render } from "./SummaryTable.vue?vue&type=template&id=3e1fbabd&scoped=true"
import script from "./SummaryTable.vue?vue&type=script&lang=js"
export * from "./SummaryTable.vue?vue&type=script&lang=js"

import "./SummaryTable.vue?vue&type=style&index=0&id=3e1fbabd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e1fbabd"]])

export default __exports__